export default {"src":"/_next/static/media/Safari App Permission.e0c5fc33.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};